import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import Common from '../Common/common';
import constClass from '../../Constants/Constants';
import { useHistory } from 'react-router-dom';
import { generatePath } from 'react-router';
import { useToasts } from 'react-toast-notifications';
import { useParams } from 'react-router';
import moment from 'moment';

const TrainCancel = (props) => {
  const history = useHistory();
  const { settings } = props;
  const [cancelfee, setcancelfee] = useState(0);
  const [ticketData, setTicketData] = useState(null);
  const { siteId, bookId, ticketId } = useParams();
  const [stopReason, setStopReason] = useState("");
  const [paymentData, setPaymentData] = useState([]);
  const [bookData, setBookData] = useState([]);
  const [bookInfoData, setBookInfoData] = useState(null);
  const [ticketInfoData, setTicketInfoData] = useState(null);
  const { addToast } = useToasts();
  const refreshMaster = useCallback(async () => {
    //トークンを取得
    const jwt = localStorage.getItem('jwt');

    var bookInfoData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/train_booking/${siteId}/${bookId}/booking`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;

    var ticketInfoData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ticket/${siteId}/${ticketId}/ticket`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;
    setBookInfoData(bookInfoData);
    setTicketInfoData(ticketInfoData);
    var reg_params = {};
    reg_params = {
      "operator": "and",
      "where": [
        { "site_id": props.siteId },
        { "book_id": props.bookId }
      ]
    }
    var param = {};
    param = {
      "operator": "and",
      "where": [
        { "site_id": props.siteId }
      ]
    }
    var payment_params = {};
    payment_params = {
      "operator": "and",
      "where": [
        { "site_id": props.siteId },
        { "transaction_id": props.bookId }
      ]
    }
    const data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/train_booking/search/`, reg_params, { headers: { Authorization: `Bearer ${jwt}` } })).data;
    const ticketdata = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket/search/`, param, { headers: { Authorization: `Bearer ${jwt}` } })).data;
    setTicketData(ticketdata);
    const paymentData = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/payment/search/`, payment_params, { headers: { Authorization: `Bearer ${jwt}` } })).data;
    setPaymentData(paymentData);
    setBookData(data);

  }, [props.siteId, bookId, props.bookId, siteId, ticketId]);

  const handleChangeStopReason = (e) => {
    const target = e.target;
    setStopReason(target.value);
  }

  const handleStatusButtonClick = async (book_id, refund_total, receipt_num, status, data_status, line_id) => {
    // キャンセル登録時にキャンセル料の最大値チェック
    const max = ticketInfoData.amount * bookInfoData.count;
    if (Number(cancelfee) > max) {
      alert(`キャンセル料は最大値（${max}円）を超えることはできません。`);
      return;
    }

    var book = bookData.find(o => (o.book_id === book_id && o.receipt_num === receipt_num));
    var message = "";
        message = `予約No[${book.book_id}]をキャンセルします。よろしいですか？`;

      if (!window.confirm(message)) {
        return;
      }
      const reg_params = {
        site_id: props.match.params.siteId,
        book_id,
        refund_total,
        upd_name: props.user.userId,
      };
      const param = {
        site_id: props.match.params.siteId,
        book_id,
        upd_name: props.user.userId,
        cancel_reason: stopReason,
      }
      try {
        //トークンを取得
        const jwt = localStorage.getItem('jwt');
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/cancel/`, reg_params, { headers: { Authorization: `Bearer ${jwt}` } });

        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/send_cancelmessage/`, param, { headers: { Authorization: `Bearer ${jwt}` } });

        try {
          history.push(`${generatePath(`${props.match.path}bookinglist`, { siteId: props.match.params.siteId })}`);
        } catch (err) {
          if (err.response.data !== null) {
            addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
          } else {
            addToast(err.response, { appearance: 'error', autoDismiss: true });
          }
        }
        addToast('ステータスを更新しました。', { appearance: 'success', autoDismiss: true });
      } catch (err) {
        if (err.response.data !== null) {
          addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
        } else {
          addToast(err.response, { appearance: 'error', autoDismiss: true });
        }
      } finally {
        //await refreshBook();
        //setLockData(false);
      }
  }

  const stopReasonItem = () => {
    const items = [];
    var list = JSON.parse(Common.getSettingValue(settings, "STOP_REASON_LIST", []));
    items.push(<option value="" key={"-"}>- 停止理由を選択してください。 -</option>)
    list.forEach((data, idx) => {
      items.push(<option value={data} key={idx}>{data}</option>)
    });
    return items;
  }

  const renderCancelButton = (data) => {
    var value_refund_total = ticketInfoData.amount * bookInfoData.count - (cancelfee ? Number(cancelfee) : 0);

    if (!data) {
      return null;
    }

    const datalist = bookData.filter(x => x.book_id === data.book_id);
    const chk = datalist.reduce((chk, item) => (chk && constClass.STATUS_PRE.includes(item.status)), true);

    // data.statusがundefinedの場合のチェック
    const statusName = "キャンセル登録";
    const status = (chk) ? constClass.STATUS.CCL : constClass.STATUS.CFIN;
    const additionalStatus = [constClass.STATUS.CCL, constClass.STATUS.CFIN];
    return (
      <button type="button"
        className={`btn ${additionalStatus.includes(data.status) ? 'btn-danger' : (constClass.ACTIVE_BUTTONS[data.status] && constClass.ACTIVE_BUTTONS[data.status].includes(status) ? 'btn-success' : 'btn-success')} mx-1`}
        onClick={() => handleStatusButtonClick(data.book_id, value_refund_total, data.receipt_num, status, data.status, data.line_id)}>
        {statusName}
      </button>
    )
  }

  const handleChange = (event) => {
    const value = event.target.value;
    // 数字でない場合のチェック
    if (value !== "" && !/^[0-9]+$/.test(value)) {
      alert('キャンセル料は0円以上の整数で入力してください。');
      setcancelfee(0);
    } else {
      // 0または空欄以外は先頭の0を除去
      if (value === "0" || value === "") {
        setcancelfee(value);
      } else {
        setcancelfee(value.replace(/^0+/, ""));
      }
    }
  };

  useEffect(() => {
    var intervalId;
    async function fetchData() {
      await refreshMaster();
      intervalId = setInterval(() => {
        refreshMaster();
      }, 60000);
    }
    fetchData();
    return () => {
      clearInterval(intervalId);
    };
  }, [refreshMaster]);

  const renderList = () => {
    if (!bookInfoData || !ticketInfoData) {
      return <div>読み込み中・・・</div>;
    }
    return (
      <div className="row pt-1 pb-2">
        <div className="col-1 text-center">予約内容</div>
        <div className="col-11">
          <table className="table table-bordered text-center" height="1">
            <thead>
              <tr>
                <th className="text-center align-middle print-none">管理<br />番号</th>
                <th className="text-center align-middle print-none">乗車日</th>
                <th className="text-center align-middle print-none">チケット</th>
                <th className="text-center align-middle print-none">人数</th>
                <th className="text-center align-middle print-none">乗車駅</th>
                <th className="text-center align-middle print-none">降車駅</th>
                <th className="text-center align-middle print-none">ステータス</th>
              </tr>
            </thead>
            <tbody>
              {bookData.filter(x => x.book_id === bookInfoData.book_id).map((data, idx) => (
                <tr key={idx}>
                  {/* 管理番号 */}
                  <td className="text-center align-middle p-1">
                    {bookInfoData.book_id}
                  </td>
                  {/* 乗車日 */}
                  <td className="text-center align-middle p-1">
                    {moment(bookInfoData.book_date).format('YYYY/MM/DD')}
                  </td>
                  {/* チケット */}
                  <td className="text-center align-middle p-1">
                    {ticketInfoData.ticket_name}
                  </td>
                  {/* 人数 */}
                  <td className="text-center align-middle p-1">
                    {bookInfoData.count}<br />
                  </td>
                  {/* 乗車駅 */}
                  <td className="text-center align-middle p-1">
                    {(() => {
                      const ticket = ticketData.find(t => t.ticket_id === Number(data.ticket_id));
                      if (!ticket) return 'チケットデータなし';
                      let foundDetail = null;
                      for (const x of ticket.ticket_detail_data) {
                        const ticketIdMatch = x.ticket_id === Number(data.ticket_id);
                        const bookingDetailMatch = data.t_booking_detail && data.t_booking_detail.find(b => b.entry_type === "E01" && b.entry_data === x.entry_data);
                        if (ticketIdMatch && bookingDetailMatch) {
                          foundDetail = x;
                          break;
                        }
                      }
                      if (!foundDetail) return '詳細データなし';
                      return foundDetail.entry_name;
                    })()}
                  </td>
                  {/* 降車駅 */}
                  <td className="text-center align-middle p-1">
                    {(() => {
                      const ticket = ticketData.find(t => t.ticket_id === Number(data.ticket_id));
                      if (!ticket) return 'チケットデータなし';
                      let foundDetail = null;
                      for (const x of ticket.ticket_detail_data) {
                        const ticketIdMatch = x.ticket_id === Number(data.ticket_id);
                        const bookingDetailMatch = data.t_booking_detail && data.t_booking_detail.find(b => b.entry_type === "E02" && b.entry_data === x.entry_data);
                        if (ticketIdMatch && bookingDetailMatch) {
                          foundDetail = x;
                          break;
                        }
                      }
                      if (!foundDetail) return '詳細データなし';
                      return foundDetail.entry_name;
                    })()}
                  </td>
                  {/* ステータス */}
                  <td className="text-center align-middle p-1">
                    {constClass.STATUS_NAME[bookInfoData.status]}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
          <div className="col-11 text-center mb-4">
            <div className="row pt-4 pb-3 d-flex justify-content-center">
              <div className="col-2 text-center align-self-center">
                <span>料金</span>
              </div>
              <div className="col-4 text-right">
                <span>{ticketInfoData.amount * bookInfoData.count}円</span>
              </div>
            </div>
            <div className="row pt-2 d-flex justify-content-center">
              <div className="col-2 text-center align-self-center">
                <span>キャンセル料</span>
              </div>
              <div className="d-flex col-4 text-right">
                <input type="number" className="form-control" value={cancelfee} onChange={handleChange} max={ticketInfoData.amount} min={0}></input>円
              </div>
            </div>
            <div className="col-8 text-right">(最大値:{ticketInfoData.amount * bookInfoData.count}円)</div>
            <div className="row pt-2 d-flex justify-content-center mt-2">
              <div className="col-2 text-center align-self-center">
                <span>払い戻し額</span>
              </div>
              <div className="col-4 text-right" value={ticketInfoData.amount * bookInfoData.count - (cancelfee ? Number(cancelfee) : 0)}>
                {ticketInfoData.amount * bookInfoData.count - (cancelfee ? Number(cancelfee) : 0)}円
              </div>
            </div>
            <div className="row pt-2 d-flex justify-content-center mt-3">
              <div className="col-2 text-center align-self-center">
                <span>キャンセル理由</span>
              </div>
              <div className="col-4 text-center align-self-center">
                <select className="custom-select w-100" aria-label="停止理由" id="stop_reason" name="stop_reason" value={stopReason} onChange={handleChangeStopReason}>
                  {stopReasonItem()}
                </select>
              </div>
            </div>
          </div>
          {bookData.filter(x => x.book_id === bookInfoData.book_id).map((data, idx) => (
            <div key={idx} className="col text-center mb-4">
              {renderCancelButton(data)}
            </div>
          ))}
        </div>
        <div className="mb-3"></div>
        <div className="col-1 text-center">決済履歴</div>
        <div className="col-11">
          <table className="table table-bbooked table-striped" height="1">
            <thead>
              <tr>
                <th className='align-middle text-center'>No</th>
                <th className='align-middle text-center'>取引ID</th>
                <th className='align-middle text-center'>利用金額</th>
                <th className='align-middle text-center'>手数料等</th>
                <th className='align-middle text-center'>決済手段</th>
                <th className='align-middle text-center'>決済状況</th>
                <th className='align-middle text-center'>更新日時</th>
              </tr>
            </thead>
            <tbody>
              {paymentData.filter(x => Number(x.transaction_id) === bookInfoData.book_id).map((data, idx) => (
                <tr key={idx}>
                  {/* No */}
                  <td className="text-center align-middle">
                    {data.payment_id}
                  </td>
                  {/* 取引ID */}
                  <td className="text-center align-middle">
                    {data.transaction_id}
                  </td>
                  {/* 利用金額 */}
                  <td className="text-center align-middle">
                    {Math.ceil(data.amount)}
                  </td>
                  {/* 手数料等 */}
                  <td className="text-center align-middle">
                    {Math.ceil(data.fee)}
                  </td>
                  {/* 決済手段 */}
                  <td className="text-center align-middle">
                    {data.payment_type}
                  </td>
                  {/* 決済状況 */}
                  <td className="text-center align-middle">
                    {constClass.JOBCDNAME[data.job_cd]}
                  </td>
                  {/* 更新日時 */}
                  <td className="text-center align-middle">
                    {(() => {
                      const dateString = data.upd_date;
                      return dateString ? moment(dateString).format('YYYY/MM/DD HH:mm:ss') : '';
                    })()}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }
  return (
    <div className="container">
      {renderList()}
    </div>
  );
}

export default TrainCancel;